import { render, staticRenderFns } from "./GrantsResource.vue?vue&type=template&id=5edf7d35&"
import script from "./GrantsResource.vue?vue&type=script&lang=js&"
export * from "./GrantsResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports